import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import HeaderConfiguration from "../components/HeaderConfiguration";
import SwitchInputPortList from '../components/SwitchInputPortList';
import PanelLayout from "../components/PanelLayout";

class OutputPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Conditions",
        };
        this.changeTab = this.changeTab.bind(this);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        return (
            <PanelLayout
                headerTabs={
                    <span data-id="Conditions"
                          onClick={this.changeTab}
                          className={this.state.selectedTab === "Conditions" ? "navigation-tab current" : "navigation-tab"}>
                        Conditions
                    </span>
                }
                customTabs
            >
                <div
                    className={this.state.selectedTab === "Conditions" ? "gui-editor-content active" : "gui-editor-content"}>
                    <HeaderConfiguration nodeName='switch'/>
                    <SwitchInputPortList/>
                </div>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {hideModal})(OutputPanel);